import { type Dispatch } from 'redux'
import {
  type SetLanguagePayload,
  type SettingsAction,
  type SetSettingsPayload,
} from './types'

export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_SETTINGS = 'SET_SETTINGS'

export const setLanguage = (payload: SetLanguagePayload) => (dispatch: Dispatch<SettingsAction>) => {
  dispatch({
    type: SET_LANGUAGE,
    payload,
  })
}

export const setSettings = (payload: SetSettingsPayload) => (dispatch: Dispatch<SettingsAction>) => {
  dispatch({
    type: SET_SETTINGS,
    payload,
  })
}
